/* Problem selector for the universal homepage.
 *
 * Deliberately plain: no framework, no fetch, no product logic. Every destination is a
 * real link rendered server-side in the markup, so the selector narrows the choice but
 * never decides for the customer — which is what the brief's selection journey asks for.
 * With JavaScript off, all five answer panels are simply hidden and the category links in
 * the rest of the page still work.
 */
(function () {
  'use strict';

  var buttons = document.querySelectorAll('[data-u-problem]');
  var answers = document.querySelectorAll('[data-u-answer]');
  if (!buttons.length) return;

  function show(key) {
    buttons.forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.uProblem === key));
    });
    var target = null;
    answers.forEach(function (a) {
      var match = a.dataset.uAnswer === key;
      a.hidden = !match;
      if (match) target = a;
    });
    if (target) {
      /* Move focus so a keyboard or screen-reader user lands on the answer rather than
         having it appear silently further down the page. */
      target.focus({ preventScroll: true });
      target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  buttons.forEach(function (b) {
    b.addEventListener('click', function () {
      var key = b.dataset.uProblem;
      /* Clicking the active choice again clears it, so the customer is never trapped
         in a branch they picked by mistake. */
      show(b.getAttribute('aria-pressed') === 'true' ? null : key);
    });
  });
})();
